let braintree;
import('braintree-web').then(lib => (braintree = lib.default));
// FYI braintree-web gziped is -132.07 KB  :<

const createBraintreeRequest = data => ({
    endpoint: 'payment_methods/credit_cards',
    method: 'post',
    data: {
        amount: data.amount,
        creditCard: {
            number: data.cardNumber,
            expirationDate: data.expDate.split(' ').join(''),
            cvv: data.cvv
        }
    }
});

let cachedBtClient = null;
const braintreeClient = clientToken => {
    if (cachedBtClient) return Promise.resolve(cachedBtClient);
    return braintree.client
        .create({
            authorization: clientToken
        })
        .then(client => (cachedBtClient = client));
};

export const requestVenmoInstance = data => {
    return braintreeClient(data.clientToken)
        .then(clientInstance =>
            braintree.venmo.create({ client: clientInstance, allowNewBrowserTab: false })
        )
        .catch(error => console.error(error));
};

export const requestBraintreePayment = data => {
    return braintreeClient(data.clientToken).then(clientInstance =>
        clientInstance.request(createBraintreeRequest(data)).then(response => {
            if (
                response == null ||
                response.creditCards == null ||
                !response.creditCards.length
            ) {
                return Promise.reject();
            }
            const nonce = response.creditCards[0].nonce;
            return { ...data, nonce };
        })
    );
};

export const deviceData = paymentInfo => {
    return braintreeClient(paymentInfo.clientToken)
        .then(client => braintree.dataCollector.create({ client, paypal: true }))
        .then(dataCollector => dataCollector.deviceData);
};
